import { render, staticRenderFns } from "./faq-component.vue?vue&type=template&id=5c5fef4c&"
import script from "./faq-component.vue?vue&type=script&lang=js&"
export * from "./faq-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports